import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import { LogoutButton } from '@ztechapps/webui.button'
import { AccountJoinContainer } from './AccountJoinContainer'

export const AccountJoinPending = () => {
  return (
    <AccountJoinContainer
      title="Wait for your administrator to accept your request and setup your account properly"
      description={
        <>
          <div>
            You still cannot login because either of the following reason
            <ul>
              <li>Your account is still in PENDING status</li>
              <li>Your application ROLES was not properly setup</li>
            </ul>
            Contact them immediately for more information
          </div>

          <p>And if you are not interested at all, just log-out.</p>
        </>
      }
    >
      <h1 className="text-center">
        <Icon name="hourglass-start" className="fa-5x text-info" />
      </h1>
      <LogoutButton />
    </AccountJoinContainer>
  )
}
